import React from 'react';
import {
  Button, ButtonToolbar, Message, Modal, Stack,
} from 'rsuite';
import { TypeAttributes } from 'rsuite/esm/internals/types';
import {
  CrossDockDispatchStatus,
  DispatchedCrossDockOrder,
  ForceDispatchCrossDockResponse,
} from '../../api/crossdock/crossDockTrackingTypes';

const STATUS_TYPES: Record<CrossDockDispatchStatus, TypeAttributes.Status> = {
  CREATED: 'success',
  CANCEL_FAILED: 'error',
  CREATE_FAILED: 'error',
  SKIPPED: 'warning',
};

interface Props {
  result?: ForceDispatchCrossDockResponse;
  onClose?: () => void;
}

function getOrderHeader(order: DispatchedCrossDockOrder): string {
  const label = order.orderIds.length > 1 ? 'Orders' : 'Order';

  return `${label} ${order.orderIds.join(', ')} – ${order.status}`;
}

export default function CrossDockForceDispatchResultDialog(
  { result, onClose }: Props,
): JSX.Element | null {
  if (!result) {
    return null;
  }

  function handleClose(): void {
    onClose?.();
  }

  return (
    <Modal
      open
      backdrop="static"
      keyboard={false}
      onClose={() => handleClose()}
    >
      <Modal.Header
        closeButton={false}
      >
        Cross dock dispatch result
      </Modal.Header>
      <Modal.Body>
        <Stack direction="column" spacing={10} alignItems="stretch">
          {result.orders.map((order) => (
            <Message
              key={order.orderIds.join('-')}
              showIcon
              type={STATUS_TYPES[order.status]}
              header={getOrderHeader(order)}
            >
              {order.message && (
                <div>{order.message}</div>
              )}
              {order.xdockProviderId && (
                <div>
                  Cross dock order id:
                  {' '}
                  {order.xdockProviderId}
                </div>
              )}
            </Message>
          ))}
        </Stack>
      </Modal.Body>
      <Modal.Footer>
        <ButtonToolbar>
          <Button
            appearance="primary"
            onClick={() => handleClose()}
          >
            Close
          </Button>
        </ButtonToolbar>
      </Modal.Footer>
    </Modal>
  );
}

CrossDockForceDispatchResultDialog.defaultProps = {
  result: undefined,
  onClose: undefined,
};
